import React from "react"
import { graphql } from "gatsby"

import { Layout } from "../../components/layout"
import { MetaHead } from "../../components/layout/meta-head"
import HeroWithSlantedEffect from "../../components/HeroWithSlantedEffect"
import HeroWithSmallFeature from "../../components/HeroWithSmallFeature"
import HeroWithGradient from "../../components/HeroWithGradient"
import { Container } from "../../components/Container"
import BlogInterest from "../../components/BlogInterest/BlogInterest"
import { BlogBackButton } from "../../components/BlogInteractionWidget"
import {BlogContent} from "../../components/BlogComponents/BlogContent"
import Modal from "../../components/Modal"

import { ShareIcon, FacebookIcon, LinkedinIcon, TwitterXIcon } from "../../components/Icons"

import "./blog-post.css"


export default function BlogPost({ data = {} }) {
  const post = data.contentfulBlogPosts
  const postCategories = data.allContentfulBlogCategories.nodes
  const postCategoryTitles = post.categories.map(category => category.title)

  const formattedDate = new Date(post.publishDate).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "2-digit",
  });

  const socialsList = [
    {
      icon: <ShareIcon/>,
      name: 'Telegram',
      link: "https://www.facebook.com/SavorBrandsInc/", 
    },
    {
      icon: <TwitterXIcon/>,
      name: 'Twitter',
      link: "https://www.facebook.com/SavorBrandsInc/", 
    },
    {
      icon: <FacebookIcon/>,
      name: 'Facebook',
      link: "https://www.facebook.com/SavorBrandsInc/",
    },
    {
      icon: <LinkedinIcon/>,
      name: 'Linkedin',
      link: "https://www.linkedin.com/company/savor-brands-inc",
    }
  ]
  
  const colorVariant = post.blogContentMedia !== null ? post.blogContentMedia.textContentColor : ''

  return (
    <Layout isHeaderDark={post.isHeaderDark} languagePreference={post.languagePreference} isDefaultHeader={true}>
      <div className={`blog-page ${colorVariant.toLowerCase()}`} style={{
        backgroundImage: post.blogContentMedia !== null ? `url(${post.blogContentMedia.image.gatsbyImageData.images.fallback.src})`:'transparent',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
       }}>
        {post.blogTemplate === "Hero with Slanted Effect" 
        ? <HeroWithSlantedEffect post={post} postCategories={postCategories} postCategoryTitles={postCategoryTitles} formattedDate={formattedDate} socialsList={socialsList}/> 
        : post.blogTemplate === "Hero with Small Feature Image" 
        ? <HeroWithSmallFeature post={post} postCategories={postCategories} postCategoryTitles={postCategoryTitles} formattedDate={formattedDate} socialsList={socialsList}/> 
        : <HeroWithGradient post={post} postCategories={postCategories} postCategoryTitles={postCategoryTitles} formattedDate={formattedDate} socialsList={socialsList}/>}
        <Container>
          {post.blogBodyContent !== null && <BlogContent post={post} />}
          <Modal />
          <BlogInterest content={post.otherBlogOfInterest} currentPostId={post.blogPostUrlSlug} displayLatestBlogPosts={post.displayLatestBlogPosts} languageVal={post.languagePreference} />
          <BlogBackButton />
        </Container>
      </div>
    </Layout>
  )
}

export const query = graphql`
  query ($slug: String!) {
    contentfulBlogPosts(blogPostUrlSlug: { eq: $slug }) {
      contentful_id
      isHeaderDark
      languagePreference
      translation {
        mainCategories {
          slugId
        }
        buttonName
        buttonLink
      }
      blogPostUrlSlug
      seoPageTitle
      metaDescription {
        metaDescription
      }
      tags
      blogTemplate
      publishDate
      title
      categories {
        title
      }
      thumbnailImage {
        gatsbyImageData(width: 2400, quality: 100)
      }
      thumbnailPosition
      excerptContentOptions
      excerpt {
        raw
      }
      introTextStyling {
        fontSize
        lineHeight
        content {
          content
        }
      }
      outroTextStyling {
        fontSize
        lineHeight
        content {
          content
        }
      }
      intro {
        intro
      }
      outro {
        outro
      }
      heroMediaLink
      hasBackdropOverlay
      author
      displayLatestBlogPosts
      otherBlogOfInterest {
        blogPostUrlSlug
      }
      blogBodyContent {
        layout
        componentTitle
        componentTitleVisibility
        media {
          gatsbyImageData(width: 2400, quality: 100)
        }
        sliderMediaCollection {
          colorPicker
          images {
            gatsbyImageData(width: 2400, quality: 100)
          }
        }
        packagingView360 {
          mediaSliderName
          titleVisibility
          colorPicker
          images { gatsbyImageData(width: 2400, quality: 100) }
        }
        youtubeVideoLink
        mediaAltText
        mediaCaption
        mediaCaptionPosition
        mediaCaptionColor
        textContent {
          textContent
        }
        gallery {
          galleryName
          galleryNameVisibility
          galleryLayoutOptions
          stackColumnNumber
          galleryFitOption
          hasWhiteBackground
          colorPicker
          gallery {
            gatsbyImageData(width: 2400, quality: 100)
          }
        }
        contentBlogPickerLayout
        contentBlogPickerColumn
        contentBlogPicker {
          parentCategory{
            categoryName
            slugId
          }
          blogPostUrlSlug
          title
          thumbnailColor
          thumbnailImage {
            gatsbyImageData(width: 2400, quality: 100)
          }
          publishDate
          includeDateDisplayInTheContentBlogPicker
          excerpt {
            raw
          }
          author
          categories {
            title
          }
        }
      }
      blogGallery {
        galleryName
        gallery {
          gatsbyImageData(width: 2400, quality: 100)
        }
      }
      hasPartnerLogo
      companyLogo {
        title
        image { gatsbyImageData(width: 2400, quality: 100) }
        altTag
        borderLayout
        hasBorder
      }
      hasContactForm
      contactFormPosition
      embedGoogleMap
      parentCategory {
        categoryName
        slugId
      }
      googleMapLink {
        raw
      }
      googleMapEmbed {
        googleMapEmbed
      }
      googleMapSettings {
        position
        googleMapEmbed {
          googleMapEmbed
        }
      }
      blogContentMedia {
        image {
          gatsbyImageData(width: 2400, quality: 100)
        }
        textContentColor
      }
      googleReviewsPosition
      googleReviews {
        name
        googleLink
        comment {
          comment
        }
        image {
          gatsbyImageData(width: 2400, quality: 100)
        }
        postedDate
        rating
        ratings
      }
    },
    allContentfulBlogCategories(
      sort: { fields: createdAt, order: ASC }  # or DESC for descending order
    ) {
      nodes {
        id
        title
        languagePreference
      }
    }
  }
`

export const Head = ({data}) => {
  const post = data.contentfulBlogPosts

  let slugUrl;
  if (post.parentCategory.categoryName !== 'Savor Stories') {
    slugUrl = `/${post.parentCategory.slugId}/${post.blogPostUrlSlug}`;
  } else {
    slugUrl = `/blog/${post.blogPostUrlSlug}`;
  }
  return (
    <MetaHead 
      title={data.contentfulBlogPosts.seoPageTitle} 
      description={data.contentfulBlogPosts.metaDescription.metaDescription} 
      titleSEO={data.contentfulBlogPosts.seoPageTitle} 
      tags={data.contentfulBlogPosts.tags} 
      seoImage={data.contentfulBlogPosts.thumbnailImage.gatsbyImageData.images.fallback.src} 
      isFollow={true}
      slugUrl={`https://www.savorbrands.com${slugUrl}/`}
      />
  )
}
